export default "__VITE_ASSET__BzLWADv2__"